import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./Products.css";
import { isValidEmail } from "../../../utils/validFormData";
import axios from "axios";
import { useTranslation } from "react-i18next";

const ProductModal = ({ showModal, handleModalClose }) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState(null);
  const [formStatus, setFormStatus] = useState({
    isLoading: false,
    isSuccess: false,
    error: null,
  });
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    company_name: "",
  });
  const resetForm = () => {
    handleModalClose();
    setErrorMessage(null);
    setUserInfo({ name: "", email: "", company_name: "" });
    setFormStatus({ isLoading: false, isSuccess: false, error: null });
  };
  const handleSubmit = async () => {
    if (!userInfo.email) {
      setErrorMessage("Email is required!");
    } else if (!isValidEmail(userInfo.email)) {
      setErrorMessage("Email is not valid");
    } else {
      setErrorMessage("");
      await handleEmailSubmission({
        first_name: userInfo.name,
        email: userInfo.email,
        company_name: userInfo.company_name,
      });
    }
  };

  const handleInputChange = ({ target: { name, value } }) => {
    setUserInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleEmailSubmission = async (data) => {
    try {
      setFormStatus({ ...formStatus, isLoading: true });
      await axios.post(
        `${process.env.REACT_APP_APIURL}contact`,
        { ...data, category: "Inquiry - Fx AI Pilot" },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      setFormStatus({ isLoading: false, isSuccess: true });
      setTimeout(resetForm, 2000);
    } catch (err) {
      setFormStatus({ isLoading: false, error: "Something went wrong!" });
    }
  };
  useEffect(() => {
    if (formStatus.error) {
      setTimeout(() => setFormStatus({ ...formStatus, error: null }), 3000);
    }
  }, [formStatus]);
  return (
    <Modal
      show={showModal}
      onHide={resetForm}
      centered
      dialogClassName="custom-modal"
    >
      <Modal.Header closeButton className="border-0"></Modal.Header>
      <Modal.Body>
        <div style={{padding:"8px"}}>
        <div className="title modal-title">
          <h2 className="gradient-text-default text-center">{t("products_development_ai_coder.title")}</h2>
        </div>
        <div className="text-center mx-auto modal-pr-desc">
          {t("products_development_ai_coder.desc")}
        </div>
        <form
          className="d-flex flex-column product-form"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="form-group">
            <label className="form-label" htmlFor="name">
            {t("products_development_ai_coder.name")}<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={userInfo.name}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="email">
            {t("products_development_ai_coder.emailid")}<span className="text-danger">*</span>
            </label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={userInfo.email}
              onChange={handleInputChange}
            />
          </div>
          <small className="form-text text-danger">{errorMessage}</small>
          <div className="form-group">
            <label className="form-label" htmlFor="company">
            {t("products_development_ai_coder.company_name")}<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              name="company_name"
              value={userInfo.company}
              onChange={handleInputChange}
            />
          </div>
          <div className="prod-modal-btn"> 
          <button
            type="submit"
            className="btn whatsapp_phonenumber_submit_btn modalBtn"
            disabled={!userInfo.email || formStatus.isLoading}
            onClick={handleSubmit}
          >
            {formStatus.isLoading ? (
              <i
                className="fa fa-spinner fa-spin mr-2 text-white"
                aria-hidden="true"
              />
            ) : formStatus.isSuccess ? (
              "Submitted"
            ) : (
              "Submit"
            )}
          </button>
          </div>
        </form></div>
      </Modal.Body>
    </Modal>
  );
};

export default ProductModal;
